import { SEASON_END_MONTH, SEASON_START_MONTH } from '@/lib/common'
import { DayData } from '@/lib/types'
import { State } from '@/store/state'
import { addDays, differenceInDays, getYear } from 'date-fns'
import { GetterTree } from 'vuex'
// @ts-ignore - this complains it can't find the module, but it works
import scssVars from '@/assets/scss/scssVars.scss'

export type Getters = {
	loading(state: State): boolean
	seasons(state: State, getters: Getters): { name: string; days: DayData[] }[]
}

export const getters: GetterTree<State, State> & Getters = {
	loading: state => {
		return state.loadingCount > 0
	},
	seasons: (state, getters) => {
		if (!state.cloudData) return []
		const startYear = getYear(
			// @ts-ignore
			state.cloudData?.features[0]?.features[0]?.properties.date
		)
		// This is the START of the final season - i.e. 1 year before our data ends
		const endYear =
			getYear(
				// @ts-ignore
				state.cloudData?.features[state.cloudData.features.length - 1]
					?.features[
					// @ts-ignore
					state.cloudData.features[state.cloudData.features.length - 1].features
						.length - 1
				].properties.date
			) - 2 // -2 because we want to ignore 2024-2025 which is incomplete
		// We want a constant number of days in a season.  The end days will change on leap years.
		const daysPerSeason = differenceInDays(
			new Date(startYear + 1, SEASON_END_MONTH - 1, 30),
			new Date(startYear, SEASON_START_MONTH - 1, 1)
		)

		const epoch = new Date(startYear, 0, 1)
		const dayNumberToIndex: {
			[key: number]: { seasonIndex: number; dayIndex: number }
		} = {}
		let si = 0
		const seasons = []
		for (let seasonYear = startYear; seasonYear <= endYear; seasonYear++) {
			let di = 0
			const days: DayData[] = []
			for (let seasonDay = 0; seasonDay < daysPerSeason; seasonDay++) {
				const date = addDays(
					new Date(seasonYear, SEASON_START_MONTH - 1, 1),
					seasonDay
				)
				const dayObj: DayData = {
					date
				}
				if (
					state.date2DisasterIndex.has(date.getTime()) &&
					state.disasterData !== null
				) {
					dayObj.disaster = state.date2DisasterIndex
						.get(date.getTime())
						// @ts-ignore
						?.map(i => state.disasterData[i])
				}
				days.push(dayObj)
				const dayNumber = differenceInDays(date, epoch)
				dayNumberToIndex[dayNumber] = {
					seasonIndex: si,
					dayIndex: di
				}
				di++
			}
			seasons.push({
				name: `${seasonYear}-${seasonYear + 1}`,
				days
			})
			si++
		}

		let cScheme = [scssVars.cloudband1, scssVars.cloudband2]
		let fci = 0
		// @ts-ignore
		for (let fc of state.cloudData?.features) {
			let fi = 0
			for (let f of fc.features) {
				const dayNumber = differenceInDays(f.properties.date, epoch)
				if (dayNumberToIndex[dayNumber]) {
					const { seasonIndex, dayIndex } = dayNumberToIndex[dayNumber]
					if (seasons[seasonIndex].days[dayIndex].cloudBlobIndex) {
						console.warn('already set - overlapping blobs')
					}
					seasons[seasonIndex].days[dayIndex].cloudBlobIndex = {
						fcIndex: fci,
						fIndex: fi
					}
					seasons[seasonIndex].days[dayIndex].color =
						cScheme[fci % cScheme.length]
					if (fi === 0) {
						// @ts-ignore
						seasons[seasonIndex].days[dayIndex].cloudBlobIndex.first = true
					}
					if (fi === fc.features.length - 1) {
						// @ts-ignore
						seasons[seasonIndex].days[dayIndex].cloudBlobIndex.last = true
					}
				}
				fi++
			}
			fci++
		}
		return seasons
	}
}
